var $ = require( 'jquery' );
import Player from '@vimeo/player';

$(document).ready(function(){

    vimeoVideos();
   
});

function vimeoVideos() {
    if ($('.vimeomain').length) {
        $('.vimeomain').each(function(){

            var videoID = $(this).attr('id');
            var videoPlayer = $(this).parent().find('.video__wrap-item__placeholder, .video__wrap-item-play-button');
            const player = new Player(videoID);

            videoPlayer.on('click', function() {
                $(this).addClass('hidden');
                player.play();
            })
            
            player.on('ended', function(data) {
                videoPlayer.removeClass('hidden');
            });
        })

    }
}